<template>
    <section>
        <Sidebar />
        <Content class="create-endpoint-page">
            <template v-if="user_plan && user_plan.plan > 0">
                <h1><i class="fas fa-flask"></i> Create new endpoint test</h1>
                <div class="">
                    <b-field label="Name" style="margin-bottom: 25px;">
                        <b-input type="text" placeholder="Name" v-model="endpoint.name"></b-input>
                    </b-field>
                </div>
                <div class="row hide">
                    <b-checkbox class="checkbox-field" v-model="endpoint.check_from"
                    native-value="0b6e54df-80d7-46e4-925d-f75467c23516">
                        US - East
                    </b-checkbox>
                    <b-checkbox class="checkbox-field" v-model="endpoint.check_from"
                        native-value="e7216120-187a-4a23-85ed-e8ecc6723e45">
                        US - West
                    </b-checkbox>
                    <b-checkbox class="checkbox-field" v-model="endpoint.check_from"
                        native-value="466a409d-f096-4764-b534-9eed95fdf8c2">
                        Europe - Amsterdam
                    </b-checkbox>
                </div>
                <div class="slider-field-interval" style="padding: 0px 15px;">
                    <b-field label="Check interval">
                        <b-slider :min="min" :max="7" :tooltip="false" size="is-large" v-model="endpoint.interval">
                            <b-slider-tick :value="1" v-if="min <= 1">1 min</b-slider-tick>
                            <b-slider-tick :value="2" v-if="min <= 2">5 min</b-slider-tick>
                            <b-slider-tick :value="3" v-if="min <= 3">15 min</b-slider-tick>
                            <b-slider-tick :value="4">30 min</b-slider-tick>
                            <b-slider-tick :value="5">1 hour</b-slider-tick>
                            <b-slider-tick :value="7">24 hours</b-slider-tick>
                        </b-slider>
                    </b-field>
                </div>
                <div class="" style="clear: both; margin-top: 75px;">
                    <b-button type="is-primary" @click="goToNextStep()">Next step</b-button>
                </div>
            </template>
            <template v-else-if="user_plan">
                <b-notification type="is-info">
                    <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i> You have not subscribed yet. Choose a plan and start using Devect
                </b-notification>
                <Plans />
            </template>
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import {getEndpoint, createEndpoint} from "../logic/endpoints"
import {getJWTContent, getUserPlan} from "../logic/global"
import constants from '../constants'
import Plans from '../components/Plans'


let endpoint = {
    "name": "",
    "check_from": ["466a409d-f096-4764-b534-9eed95fdf8c2"],
    "interval": 3,
    "status": 0,
}

export default {
    name: 'APITestCreate',
    components: {Sidebar, Content, Plans},
    data() {
        return {
            endpoint: endpoint,
            user_plan: null,
            plan_limitations: null,
            min: 1
        }
    },
    methods: {
        goToNextStep: function(){
            this.endpoint["user"] = getJWTContent()["id"]
            createEndpoint(this.endpoint).then(response => {
                this.$router.push({name: "home"})
            }).catch(error => {

            });
        }
    },
    mounted: function(){
        getUserPlan().then(response => {
            this.user_plan = response.data
            this.plan_limitations = constants.PLANS_LIMITATIONS[this.user_plan.plan]
            this.min = constants.PLANS_LIMITATIONS[this.user_plan.plan].interval
            console.log()
            if(this.user_plan.plan == 0){
                this.endpoint.interval = 7
            }
        })
    }
}
</script>

<style scoped>
  h1{margin-bottom: 24px;}
  .checkbox-field{margin-right: 35px;}
  #create-endpoint-page >>> .b-slider.is-large .b-slider-tick-label{margin-top: 12px;}
  .slider-field-interval >>> label{margin-left: -15px; margin-top: 30px;}
  .slider-field-interval >>> .b-slider-tick-label{margin-top: 13px !important; width: 60px; text-align: center;}
</style>